import { Modal } from './Modal'
import { Button } from './Button'

/** Descriptive confirmation modal — replaces browser confirm() per QA ruleset.
 *  `confirmDisabled` blocks the primary action when the caller can already
 *  tell the operation would fail on the server (e.g. deleting a plan with
 *  active tenants). The button stays visible so the user still sees the
 *  action, but can't click it — the message body explains why. */
export function ConfirmDialog({
  open,
  onCancel,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  confirming,
  confirmDisabled = false,
  // Passed through to Modal so a confirm opened from above the modal layer
  // (e.g. the comments popover at zIndex 80) can raise its overlay above it.
  overlayZClass,
}) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      size="sm"
      overlayZClass={overlayZClass}
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} disabled={confirming}>
            {cancelLabel}
          </Button>
          <Button
            variant={variant}
            onClick={onConfirm}
            loading={confirming}
            disabled={confirmDisabled}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      {/* `break-words` + `overflow-wrap: anywhere` so a long, space-less
       *  value embedded in the message (e.g. a task name) wraps inside the
       *  dialog instead of forcing a horizontal scrollbar. */}
      <p className="text-sm text-[color:var(--color-ink)] break-words [overflow-wrap:anywhere]">
        {message}
      </p>
    </Modal>
  )
}
